// extracted by mini-css-extract-plugin
module.exports = {"section12":"Section12_section12__s_vTt"};